import React, { Component } from "react";
import ReactGA from "react-ga";
import axios from "axios";
import "./App.scss";
import { Tooltip } from "react-tooltip";

let ethPriceUrl = "https://api.exchange.coinbase.com/products/ETH-USD/stats";
let CBETHPriceUrl =
  "https://api.exchange.coinbase.com/products/CBETH-USD/stats";
let CBETHETHPriceUrl =
  "https://api.exchange.coinbase.com/products/CBETH-ETH/stats";
let CBETHConversionRateUrl =
  "https://api.exchange.coinbase.com/wrapped-assets/CBETH/";
let CBETHHelpUrl = "https://coinbase.com/cbeth";
let avatarUrl =
  "https://pbs.twimg.com/profile_images/1580621339471347712/BbmUxUwJ_400x400.jpg";
let twitterUrl = "https://twitter.com/0xRishi";
let apiDocsUrl =
  "https://docs.cloud.coinbase.com/exchange/reference/exchangerestapi_getwrappedasset";
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

ReactGA.initialize("UA-238613983-1");
ReactGA.pageview(window.location.pathname + window.location.search);

class App extends Component {
  state = {
    ethPrice: null,
    lastETHPrice: null,
    ethOpen: null,
    CBETHOpen: null,
    CBETHPrice: null,
    CBETHETHPrice: null,
    CBETHFairValueConversionRate: null,
    loading: true,
    apiError: false,
    CBETHCircSupply: null,
  };

  componentDidMount() {
    if (this.fetched) {
      return;
    }

    this.getRates();

    let max = 35;
    let interval = 3500;
    try {
      this.connect(max, interval);
    } catch (err) {
      console.log(err);
    }
    setInterval(this.getRates, 15000);
  }

  getRates = async () => {
    this.fetched = axios
      .get(ethPriceUrl)
      .then((res) => {
        let { data } = res;
        let { last: ethPrice, open: ethOpen } = data;

        axios
          .get(CBETHPriceUrl)
          .then(async (res) => {
            let { data } = res;

            let { last: CBETHPrice, open: CBETHOpen } = data;

            this.setState(
              {
                ethPrice: parseFloat(ethPrice),
                CBETHPrice: parseFloat(CBETHPrice),
                ethOpen,
                CBETHOpen,
              },
              () => {
                if (!this.state.CBETHFairValueConversionRate) {
                  axios
                    .get(CBETHConversionRateUrl)
                    .then((res) => {
                      let { data } = res;
                      let {
                        conversion_rate: CBETHFairValueConversionRate,
                        circulating_supply: CBETHCircSupply,
                        apy: CBETHAPY,
                        total_supply: CBETHTotalSupply,
                      } = data;

                      this.setState({
                        CBETHFairValueConversionRate: parseFloat(
                          CBETHFairValueConversionRate
                        ),
                        CBETHFairValueExchangeRate:
                          parseFloat(CBETHFairValueConversionRate) *
                          parseFloat(ethPrice),
                        CBETHMarketCap:
                          parseFloat(CBETHCircSupply) * this.state.CBETHPrice,
                        CBETHCircSupply: parseFloat(CBETHCircSupply),
                        CBETHTotalSupply: parseFloat(CBETHTotalSupply),
                        CBETHAPY: parseFloat(CBETHAPY),
                        apiError: false,
                      });
                    })
                    .catch((err) => this.setState({ apiError: true }));
                }

                axios
                  .get(CBETHETHPriceUrl)
                  .then((res) => {
                    let { data } = res;
                    let { last: CBETHETHPrice, open: CBETHETHOpen } = data;
                    this.setState({
                      CBETHETHPrice,
                      CBETHETHOpen,
                      loading: false,
                    });
                  })
                  .catch((err) => console.log(err));
              }
            );
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => this.setState({ apiError: true }));
  };

  connect = (max, interval) => {
    let counter = 0;
    const ws = new WebSocket("wss://ws-feed.exchange.coinbase.com");

    let apiCall = {
      type: "subscribe",
      channels: [
        { name: "ticker", product_ids: ["ETH-USD", "CBETH-USD", "CBETH-ETH"] },
      ],
    };

    ws.onopen = (event) => {
      ws.send(JSON.stringify(apiCall));
    };

    ws.onmessage = async (event) => {
      const json = JSON.parse(event.data);

      try {
        counter++;

        if (counter === max) {
          counter = 0;
          ws.close();
          setTimeout(() => this.connect(max, interval), interval);
        }

        if (json.product_id === "ETH-USD" && json.price) {
          this.setState({ ethPrice: parseFloat(json.price) });
        } else if (json.product_id === "CBETH-USD" && json.price) {
          this.setState({ CBETHPrice: parseFloat(json.price) });
        } else if (json.product_id === "CBETH-ETH" && json.price) {
          this.setState({ CBETHETHPrice: parseFloat(json.price) });
        }
      } catch (err) {
        console.log(err);
      }
    };

    ws.onclose = async () => {
      ws.close();
    };

    ws.onerror = async (event) => {
      console.log(event);
    };
  };

  render() {
    let {
      ethPrice,
      CBETHPrice,
      CBETHFairValueConversionRate,
      loading,
      CBETHCircSupply,
      CBETHTotalSupply,
      ethOpen,
      CBETHOpen,
      CBETHETHPrice,
      CBETHAPY,
      CBETHETHOpen,
      apiError,
    } = this.state;

    let CBETHPriceChange, CBETHETHPriceChange; // commented out ethPriceChange

    if (ethPrice && ethOpen && CBETHPrice && CBETHOpen && CBETHETHOpen) {
      // ethPriceChange = ((ethPrice - ethOpen) / ethOpen) * 100;
      CBETHPriceChange = ((CBETHPrice - CBETHOpen) / CBETHOpen) * 100;
      CBETHETHPriceChange =
        ((CBETHETHPrice - CBETHETHOpen) / CBETHETHOpen) * 100;
    }

    return (
      <div className="container">
        <div className="header-row">
          <div className="header">cbETH Rates</div>
          {!ethPrice ? null : (
            <a
              target="_blank"
              rel="noreferrer"
              href="https://exchange.coinbase.com/trade/ETH-USD"
            >
              <span className="price-change-pos price-link-out">
                ${ethPrice} (ETH/USD)
              </span>
            </a>
          )}
        </div>
        <div className="badge-row">
          <div className="created-by">Created by</div>
          <a
            target="_blank"
            rel="noreferrer"
            href={twitterUrl}
            className="made-by"
          >
            <img alt="pengu avatar" className="avatar" src={avatarUrl} />
            <span className="blink">@0xRishi →</span>
          </a>
        </div>
        {loading ? (
          <div className="label">Fetching data...</div>
        ) : (
          <>
            {apiError ? (
              <div className="api-error">
                The{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={CBETHConversionRateUrl}
                >
                  Exchange API
                </a>{" "}
                used to fetch CBETH metrics is currently down. Once the endpoint
                is restored, this dashboard will resume streaming data.
              </div>
            ) : null}
            {/* CBETH Conversion Rate */}
            <p className="data-row">
              <span className="datapoint">
                {CBETHFairValueConversionRate || NaN}
              </span>{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={apiDocsUrl}
                data-tooltip-id="conversion-rate"
                data-tooltip-content="The fair value rate of cbETH, which takes into account the amount of ETH staked, any post-commission rewards earned, any
                penalties imposed, and total cbETH token supply"
              >
                <Tooltip disable={isMobile} id="conversion-rate" />
                <span className="datalabel">CBETH:ETH Conversion Rate</span>
              </a>
            </p>

            {/* CBETH-ETH Actual Exchange Rate */}
            <p className="data-row">
              <span className="datapoint" id="CBETHRate">
                {CBETHETHPrice}
              </span>{" "}
              <span
                className={
                  CBETHETHPriceChange > 0
                    ? "price-change-pos"
                    : "price-change-neg"
                }
              >
                {CBETHETHPriceChange > 0 ? "+" : null}
                {CBETHETHPriceChange.toFixed(2)}%
              </span>{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://exchange.coinbase.com/trade/CBETH-ETH"
                data-tooltip-id="cbeth-eth-exch-rate"
                data-tooltip-content="Last trade price of CBETH/ETH order book on Coinbase Exchange"
              >
                <Tooltip disable={isMobile} id="cbeth-eth-exch-rate" />
                <span className="datalabel">
                  Actual CBETH/ETH Exchange Rate
                </span>
              </a>
            </p>

            {/* CBETH-ETH Discount */}
            <p className="data-row">
              <span className="datapoint" id="CBETHPremiumDiscount">
                {new Intl.NumberFormat("en").format(
                  Math.abs(
                    (1 - CBETHETHPrice / CBETHFairValueConversionRate) * 100
                  ).toFixed(4)
                )}
                %
              </span>{" "}
              <span
                className="datalabel"
                data-tooltip-id="discount-eth"
                data-tooltip-content={
                  CBETHETHPrice / CBETHFairValueConversionRate > 1
                    ? "CBETH/ETH is trading at a premium; the exchange rate is greater than the fair value conversion rate"
                    : "CBETH/ETH is trading at a discount; the exchange rate is less than the fair value conversion rate"
                }
              >
                <Tooltip disable={isMobile} id="discount-eth" />
                CBETH/ETH{" "}
                {CBETHETHPrice / CBETHFairValueConversionRate > 1
                  ? "Premium 🔥"
                  : "Discount"}
              </span>
            </p>

            <hr className="divider" />

            {/* Implied CBETH-USD Fair Value */}
            <p className="data-row">
              <span className="datapoint" id="impliedCBETHRate">
                $
                {new Intl.NumberFormat("en").format(
                  (CBETHFairValueConversionRate * ethPrice).toFixed(2)
                )}
              </span>{" "}
              <span
                className="datalabel"
                data-tooltip-id="fair-value"
                data-tooltip-content="Product of CBETH:ETH Conversion Rate and ETH/USD Price"
              >
                <Tooltip disable={isMobile} id="fair-value" />
                Implied CBETH/USD Fair Value Rate
              </span>
            </p>

            {/* CBETH-USD Actual Exchange Rate */}
            <p className="data-row">
              <span className="datapoint" id="CBETHRate">
                ${new Intl.NumberFormat("en").format(CBETHPrice.toFixed(2))}
              </span>{" "}
              <span
                className={
                  CBETHPriceChange > 0 ? "price-change-pos" : "price-change-neg"
                }
              >
                {CBETHPriceChange > 0 ? "+" : null}
                {CBETHPriceChange.toFixed(2)}%
              </span>{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://exchange.coinbase.com/trade/CBETH-USD"
                data-tooltip-id="cbeth-usd-exch-rate"
                data-tooltip-content="Last trade price of CBETH/USD order book on Coinbase Exchange"
              >
                <Tooltip disable={isMobile} id="cbeth-usd-exch-rate" />
                <span className="datalabel">
                  Actual CBETH/USD Exchange Rate
                </span>
              </a>
            </p>

            {/* CBETH-USD Discount */}
            <p className="data-row">
              <span className="datapoint" id="CBETHPremiumDiscount">
                {new Intl.NumberFormat("en").format(
                  Math.abs(
                    (1 -
                      CBETHPrice / (CBETHFairValueConversionRate * ethPrice)) *
                      100
                  ).toFixed(4)
                )}
                %
              </span>{" "}
              <span
                className="datalabel"
                data-tooltip-id="discount-usd"
                data-tooltip-content={
                  CBETHPrice / (CBETHFairValueConversionRate * ethPrice) > 1
                    ? "CBETH/USD is trading at a premium; the exchange rate is greater than the fair value conversion rate"
                    : "CBETH/USD is trading at a discount; the exchange rate is less than the fair value conversion rate"
                }
              >
                <Tooltip disable={isMobile} id="discount-usd" />
                CBETH/USD{" "}
                {CBETHPrice / (CBETHFairValueConversionRate * ethPrice) > 1
                  ? "Premium 🔥"
                  : "Discount"}
              </span>
            </p>

            <hr className="divider" />

            {/* APY & Market Cap */}
            <p className="data-row">
              <span className="datapoint" id="CBETHMarketCap">
                {(CBETHAPY * 100).toFixed(2)}%
              </span>{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={apiDocsUrl}
                data-tooltip-id="implied-apy"
                data-tooltip-content="Current annualized percentage yield earned as the net rewards by the staked ETH underlying cbETH. This estimate is based on the past 7 days of staking performance and is updated daily. For more details, refer to the rate calculation section of the cbETH whitepaper"
              >
                <Tooltip disable={isMobile} id="implied-apy" />
                <span className="datalabel">Implied APY</span>
              </a>
            </p>
            <p className="data-row">
              <span className="datapoint" id="CBETHSupply">
                {new Intl.NumberFormat("en").format(parseInt(CBETHCircSupply))}{" "}
                /{" "}
                {new Intl.NumberFormat("en").format(parseInt(CBETHTotalSupply))}
              </span>{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={apiDocsUrl}
                data-tooltip-id="supply"
                data-tooltip-content={
                  "[Circulating] Number of CBETH units in possession of customers (excludes CBETH pre-minted and held in abeyance). [Total] Number of CBETH units that have been minted and exist on-chain"
                }
              >
                <Tooltip disable={isMobile} id="supply" />
                <span className="datalabel">Circulating / Total Supply</span>
              </a>
            </p>
            <p className="data-row">
              <span className="datapoint" id="CBETHMarketCap">
                $
                {new Intl.NumberFormat("en").format(
                  (CBETHCircSupply * CBETHPrice).toFixed(0)
                )}
              </span>{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={apiDocsUrl}
                data-tooltip-id="market-cap"
                data-tooltip-content="Product of Circulating Supply and CBETH/USD Price"
              >
                <Tooltip disable={isMobile} id="market-cap" />
                <span className="datalabel">Implied Market Cap</span>
              </a>
            </p>
            <hr className="divider" />
            <p className="small gray">
              Note: Coinbase Wrapped Staked ETH (CBETH) represents staked ETH
              plus accrued staking interest. It’s not meant to track 1:1 with
              ETH.
            </p>
            <a
              target="_blank"
              rel="noreferrer"
              href={CBETHHelpUrl}
              className="button"
            >
              Learn more →
            </a>
          </>
        )}
      </div>
    );
  }
}

export default App;
